export  const faqData = {
    Оренда: [
        {
            question: "Як я можу орендувати ігровий комплект?",
            answer:
                "Для оренди виберіть бажаний комплект, встановіть термін оренди за допомогою повзунка, та натисніть «Замовити». Заповніть необхідні поля і натисніть кнопку «Оформити оренду». Після цього наш менеджер зв’яжеться з вами для уточнення деталей.",
        },
        {
            question: "Які умови оренди?",
            answer:
                "Умови залежать від обраного комплекту та тривалості оренди. Це може бути грошова застава. Менеджер підкаже найзручніший варіант саме для вас.",
        },
        {
            question: "Які комплекти доступні для оренди?",
            answer: `
        Доступні популярні ігрові консолі: PlayStation, Xbox та VR-набори.<br><br>
        Усі комплекти включають:
        <ul>
            <li>2 геймпади</li>
            <li>Зарядну станцію</li>
            <li>VR-шолом — з додатковою батареєю</li>
        </ul>
        Актуальні варіанти та наявність — на сайті або за запитом менеджеру.
    `,
        },
        {
            question: "Чи можу я орендувати кілька комплектів одночасно?",
            answer:
                "Один комплект можна орендувати на одну особу або за одним замовленням. Якщо потрібно більше — напишіть нам, і ми розглянемо можливість індивідуально.",
        },
        {
            question: "Як я можу продовжити оренду?",
            answer:
                "Продовжити оренду можна до закінчення поточного терміну. Для цього, просто зв'яжіться з нами.",
        },
        {
            question: "Як відбувається складання договору?",
            answer:
                "Ми можемо підготувати договір заздалегідь або заповнити його разом із вами при передачі комплекту. Повідомте менеджеру, як вам зручніше.",
        },
        {
            question: "Який мінімальний і максимальний термін оренди?",
            answer:
                "Мінімальний термін — 1 доба. Максимальний не обмежений. Оберіть зручний період під час оформлення замовлення — ми підлаштуємось під вас.",
        },
        {
            question: "Чи можна змінити термін оренди після оформлення?",
            answer:
                "Так, якщо ви хочете продовжити або скоригувати термін — повідомте менеджера заздалегідь. Ми завжди намагаємось бути гнучкими.",
        },
        {
            question: "Що, якщо комплект вийде з ладу під час оренди?",
            answer:
                "Якщо проблема не з вашої вини — ми замінимо обладнання або вирішимо питання індивідуально. У будь-якому випадку — просто зв’яжіться з нами.",
        },

    ],
    Ціни: [
        {
            question: "Яка вартість оренди комплекту?",
            answer:
                "Ціна залежить від обраного комплекту та кількості днів. Чим довший термін — тим вигідніша ціна за добу. Актуальні тарифи вказані біля кожного комплекту.",
        },
        {
            question: "Як я можу оплатити оренду?",
            answer:
                "Ми приймаємо як готівкову, так і безготівкову оплату.",
        },
        {
            question: "Чи є знижки при тривалій оренді?",
            answer:
                "У нас передбачена система заохочення постійних клієнтів. Для уточнень зверніться до нашого менеджера.",
        },
        {
            question: "Як здійснюється повернення застави?",
            answer:
                "Після повернення комплекту наш менеджер перевірить його стан, оформить акт про закриття договору оренди та поверне заставу, вказану в договорі.",
        },
        {
            question: "Чи приймаєте ви іноземну валюту у заставу?",
            answer:
                "Так, ми можемо прийняти суму застави в іншій валюті. Однак у договорі буде вказана лише національна валюта, а сума застави в іноземній валюті буде конвертована за поточним курсом до національної валюти на момент оформлення.",
        },
        {
            question: "Чи є додаткові платні послуги при оренді комплектів?",
            answer:
                "Так. Додатково можна додати ігрову підписку - PS Plus, EA Play, Game Pass. Додаткові ігри і аксесуари.",
        },
        {
            question: "Чи є акції та спеціальні пропозиції для оренди?",
            answer:
                "Так, ми часто проводимо акції для наших клієнтів. Для отримання актуальної інформації слідкуйте за новинами на нашому сайті або звертайтеся до менеджера.",
        },
        {
            question: "Чи є можливість обрати тариф для оренди на кілька годин?",
            answer:
                "Ми працюємо виключно за добовим тарифом.",
        },
    ],
    // Доставка: [
        // {
            // question: "Як відбувається доставка?",
            // answer:
                // "Доставка по місту Дніпро починається від 250 грн. При оренді від 7 днів доставка безкоштовна. Для точної вартості доставки скористайтеся інтерактивною картою на нашому сайті. Також є можливість самовивозу з нашого магазину.",
        // },
        // {
            // question: "Чи врахована вартість забирання консолі в доставку?",
            // answer:
                // "Вартість забирання консолі не включена в вартість доставки. Вартість доставки і забирання однакова і визначається в залежності від відстані до нашого магазину. Ви можете дізнатися точну суму, скориставшись інтерактивною картою на нашому сайті.",
        // },
        // {
            // question: "В які райони є доставка?",
            // answer:
                // "Ми доставляємо в усі райони міста Дніпро.",
        // },
        // {
            // question: "Чи можна змінити адресу доставки після оформлення замовлення?",
            // answer:
                // "Так, ви можете змінити адресу доставки до моменту фактичного отримання комплекту. Якщо нова адреса знаходиться в іншій зоні доставки, вартість буде перерахована відповідно до нового місцезнаходження.",
        // },
        // {
            // question:
                // "Як я можу повернути консоль після оренди?",
            // answer:
                // "Ви можете повернути консоль самостійно в наш магазин або організувати зворотну доставку через кур'єра. Для детальнішої інформації зв'яжіться з нашим менеджером.",
        // },
        // {
            // question:
                // "Якщо моєї адреси немає в зоні доставки (вона за зоною)",
            // answer:
                // "Ви можете під'їхати в зручний край зони доставки або забрати комплект особисто в нашому магазині.",
        // },
        // {
            // question:
                // "Як швидко здійснюється доставка?",
            // answer:
                // "Час доставки залежить від вашого місцезнаходження. Зазвичай доставка займає від 1 до 3 робочих годин по місту Дніпро. Точний час доставки можна дізнатися у наших менеджерів. ",
        // },
        // {
            // question:
                // "Яка вартість доставки в інші міста України?",
            // answer:
                // "Вартість доставки в інші міста залежить від перевізника - Нова Пошта. Для оформлення оренди в інші міста України, будь ласка, зверніться до нашого менеджера для отримання детальної інформації.",
        // },
        // {
            // question:
                // "Чи можна обрати дату та час доставки?",
            // answer:
                // "Так, ви можете обрати зручну для вас дату та час доставки під час оформлення замовлення. Наш менеджер зв'яжеться з вами для уточнення деталей.",
        // },
    // ],
    Інше: [
        {
            question: "Чи потрібно мати телевізор або монітор для гри?",
            answer:
                "Так, для гри вам знадобиться телевізор або монітор з HDMI-входом.",
        },
        {
            question: "Чи є обмеження за віком для оренди консолі?",
            answer:
                "Так, оформити договір оренди може особа віком від 18 років за наявності паспорта або ID-картки.",
        },
        {
            question: "Чи можна протестувати комплект перед орендою?",
            answer:
                "У нашому магазині ви можете перевірити комплект перед оформленням оренди. Ми завжди демонструємо працездатність обладнання перед видачею.",
        },
        {
            question: "Що входить у стандартний ігровий комплект?",
            answer:
                "Усі комплекти включають консоль, 2 геймпади, зарядну станцію. Додатково є можливість додати ігрові підписки, ігри і аксесуари. ",
        },
        {
            question: "Що робити, якщо обладнання перестало працювати під час оренди?",
            answer:
                "Якщо виникли технічні проблеми — негайно зв'яжіться з менеджером. Ми оперативно замінимо комплект або вирішимо проблему іншим зручним способом.",
        },
        {
            question: "Чи можна забронювати комплект заздалегідь?",
            answer:
                "Так, ви можете оформити попереднє бронювання ігрового комплекту на бажану дату. Це гарантує наявність потрібної вам моделі у зазначений час.",
        },
        {
            question: "Що робити, якщо я ніколи не користувався ігровою консоллю або VR-шоломом? Ви навчите?",
            answer:
                "Звісно! Ми все підключимо та налаштуємо за вас. Перед орендою ми покажемо, як користуватись комплектом, пояснимо керування та відповімо на всі ваші запитання. А якщо щось буде незрозуміло під час гри — наш менеджер завжди на зв’язку, щоб допомогти.",
        },
    ],
};